import React from "react";
import { DashboardLite } from "../../../../../../../Dashboards/view/Dashboard/Lite";
import { Navigate, useParams } from "react-router";
import { useEventPath } from "../../../../../../hooks/useEventPath";
import { useEventDashboards } from "../../../../../../../../../api/events/dashboards";
import { toPath } from "../../../../../../../../../router/helpers/path";
import { spacings } from "@ui/Theme";

export const DashboardTab = () => {
  const { projectId, dashboardId } = useParams();
  if (!projectId) throw new Error("no project");
  if (!dashboardId) throw new Error("no dashboard");

  const { eventPath, eventPathParameters } = useEventPath();
  const eventDashboards = useEventDashboards(eventPathParameters);

  if (eventDashboards.every(eventDashboard => eventDashboard.dashboardId !== dashboardId))
    return <Navigate to={toPath(`${eventPath}/fault`, eventPathParameters)} />;

  return (
    <div style={{ paddingLeft: spacings.xxl, paddingRight: spacings.xxl }}>
      <DashboardLite projectId={projectId} dashboardId={dashboardId} className="lite" />
    </div>
  );
};
